<div class="layout-container">
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
  <footer></footer>
</div>
